import moment from "moment";
import { errorAlert } from "../Static_Services/Alertmsg";

export const classStatusOptions = [
    { 'value': 'Active', "label": "Active" },
    { 'value': 'Deactive', "label": "Deactive", },
]


export const returnSummery = (data, name) => {
    if (!data?.length) return;
    let basePrice = 0.00,
        discount = 0.00,
        adjPrice = 0.00,
        tax1 = 0.00,
        tax2 = 0.00,
        subTotal = 0.00,
        finalTip = 0.00,
        count = 0;

    data.forEach((e) => {
        count += 1;
        let tip = 0.00;
        const parsedTip = parseFloat(e.tip_comment) || 0;
        if (e.tip_comment && !isNaN(parsedTip)) {
            tip = Math.abs(parsedTip);
        }
        basePrice += parseFloat(e?.finalBaseAmount || 0);
        discount += parseFloat(e?.finalDiscount || 0);
        adjPrice += parseFloat(e?.finalAdjustPrice || 0);
        tax1 += parseFloat(e?.finalTax1 || 0);
        tax2 += parseFloat(e?.finalTax2 || 0);
        subTotal += parseFloat(e?.finalAdjustPrice || 0) + tip + parseFloat(e?.finalTax1 || 0) + parseFloat(e?.finalTax2 || 0);
        finalTip += tip;
    });
    return {
        summary: name,
        transaction: count,
        basePrice: basePrice.toFixed(2),
        discount: discount.toFixed(2),
        adjPrice: adjPrice.toFixed(2),
        tip: finalTip.toFixed(2),
        tax1: tax1.toFixed(2),
        tax2: tax2.toFixed(2),
        subTotal: subTotal.toFixed(2),
    };
};


export const reportSummeryCalculator = (data, name) => {
    if (!data?.length) return;
    let basePrice = 0.00,
        discount = 0.00,
        adjPrice = 0.00,
        tax1 = 0.00,
        tax2 = 0.00,
        subTotal = 0.00,
        finalTip = 0.00,
        count = 0;

    data.forEach((e) => {
        count += 1;
        let tip = 0.00;
        const parsedTip = parseFloat(e.tip_comment) || 0;
        if (e.tip_comment && !isNaN(parsedTip)) {
            tip = Math.abs(parsedTip);
        }
        basePrice += parseFloat(e?.finalBaseAmount || 0);
        discount += parseFloat(e?.finalDiscount || 0);
        adjPrice += parseFloat(e?.finalAdjustPrice || 0);
        tax1 += parseFloat(e?.finalTax1 || 0);
        tax2 += parseFloat(e?.finalTax2 || 0);
        subTotal += parseFloat(e?.finalAdjustPrice || 0) + tip + parseFloat(e?.finalTax1 || 0) + parseFloat(e?.finalTax2 || 0);
        finalTip += tip;
    });
    return {
        summary: name,
        transaction: count,
        basePrice: basePrice.toFixed(2),
        discount: discount.toFixed(2),
        adjPrice: adjPrice.toFixed(2),
        tip: finalTip.toFixed(2),
        tax1: tax1.toFixed(2),
        tax2: tax2.toFixed(2),
        subTotal: subTotal.toFixed(2),
    };
};


export const checkCardExpire = (timeStamp) => {
    if (!timeStamp) { return false }
    const expDate = moment(timeStamp * 1000);
    const now = moment();
    if (expDate.isBefore(now)) {
        errorAlert("❌ Cannot add a punch. Please update the expiration date first, as it must be greater than the current date before adding punches.");
        return false;
    }
    return true;
}




export const hasAnyTrue = (apply_to) => {
    if (!apply_to) return "";

    try {
        const data = typeof apply_to === "string"
            ? JSON.parse(apply_to)
            : apply_to;

        return Object.keys(data)
            .filter(key => data[key] === true)
            .join(", ");
    } catch (error) {
        return "";
    }
};


export const formatString = (str) => {
    return str.trim().toUpperCase();
}

